import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBaseFiltersApiResponse} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchFileStatusesThunk: any = createAsyncThunk<IBaseFiltersApiResponse>(
  `${prefix} fetchFileStatuses`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getFilterFileStatuses();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch file statuses. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
